import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import lang from 'hh-shared/dist/language/services/languageService';
import BreadcrumbsContainer from 'hh-shared/dist/components/commons/BreadcrumbsContainer';
import FormPreviewSectionContainer from 'hh-shared/dist/components/layout/FormPreview/FormPreviewSectionContainer';
import FormCardWrapper from 'hh-shared/dist/components/layout/FormPreview/FormCardWrapper';
import TransportOrderInformationFormContainer from './TransportOrderInformationForm/TransportOrderInformationFormContainer';
import TransportOrdersManagementSrv from './TransportOrdersManagementSrv';
import TransportOrdersManagementPagePreviewContainer from './TransportOrdersManagementPagePreviewContainer';

const propTypes = {
  match: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  onGetDefaultPrices: PropTypes.func.isRequired,
  dispatchCancelSuccessToast: PropTypes.func.isRequired,
};

const defaultProps = {};

class TransportOrdersManagementEditPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {},
      showSpinner: false,
      facilities: [],
      companies: [],
      users: [],
      cars: [],
      addresses: [],
      carTypes: [],
      currencies: [],
    };

    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    this.setState({ showSpinner: true });

    this.props.onGetDefaultPrices();

    Promise.all([
      TransportOrdersManagementSrv.get(this.props.match.params.id),
      TransportOrdersManagementSrv.getFacilitiesAsSelectItems(),
      TransportOrdersManagementSrv.getCompaniesAsSelectItems(),
      TransportOrdersManagementSrv.getAddressesAsSelectItem(),
      TransportOrdersManagementSrv.getCarTypesAsSelectItems(),
      TransportOrdersManagementSrv.getCurrenciesAsSelectItems(),
    ])
      .then(
        ([
          initialValues,
          facilities,
          companies,
          addresses,
          carTypes,
          currencies,
        ]) => {
          this.setState({
            initialValues,
            facilities,
            companies,
            addresses,
            carTypes,
            currencies,
          });
        },
      )
      .finally(() => this.setState({ showSpinner: false }));
  }

  handleCancel() {
    this.setState({ showSpinner: true });
    return TransportOrdersManagementSrv.cancel(this.props.match.params.id)
      .then(() => {
        this.props.history.goBack();
        this.props.dispatchCancelSuccessToast();
      })
      .finally(() => this.setState({ showSpinner: false }));
  }

  render() {
    const { onSubmit, history } = this.props;
    const {
      initialValues,
      showSpinner,
      facilities,
      companies,
      users,
      cars,
      addresses,
      carTypes,
      currencies,
    } = this.state;

    return (
      <>
        <BreadcrumbsContainer
          links={[
            {
              routePath: '/',
              label: lang.labels.MainPage(),
            },
            {
              routePath: '/transport-orders-management',
              label: lang.labels.TransportOrders(),
            },
            {
              routePath: '/transport-orders-management/edit',
              label: lang.labels.EditingTransportOrder(),
            },
          ]}
        />
        <FormPreviewSectionContainer>
          <FormCardWrapper>
            <div className={showSpinner ? 'fox_spinner' : undefined}>
              <TransportOrderInformationFormContainer
                onSubmit={onSubmit}
                initialValues={initialValues}
                history={history}
                facilities={facilities}
                companies={companies}
                users={users}
                cars={cars}
                addresses={addresses}
                carTypes={carTypes}
                currencies={currencies}
                isEditForm
                onCancel={this.handleCancel}
              />
            </div>
          </FormCardWrapper>
          <TransportOrdersManagementPagePreviewContainer />
        </FormPreviewSectionContainer>
      </>
    );
  }
}

TransportOrdersManagementEditPage.propTypes = propTypes;
TransportOrdersManagementEditPage.defaultProps = defaultProps;

export default TransportOrdersManagementEditPage;
